import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import history from "./history";
import reportWebVitals from "./reportWebVitals";
import theme from "../src/Assests/styles/theme";
import { Provider } from "react-redux";
import { ThemeProvider } from "@mui/material";
import { store } from "./Store/store";
import "./index.css";
import "./i18.js";

const root = ReactDOM.createRoot(document.getElementById("root"));

const deferThirdPartyAssets = () => {
  const addClarity = () => {
    if (document.getElementById("clarity-script")) {
      return;
    }

    window.clarity =
      window.clarity ||
      function () {
        (window.clarity.q = window.clarity.q || []).push(arguments);
      };

    const clarityScript = document.createElement("script");
    clarityScript.id = "clarity-script";
    clarityScript.async = true;
    clarityScript.defer = true;
    clarityScript.src = "https://www.clarity.ms/tag/s5exz4hnj9";
    document.head.appendChild(clarityScript);
  };

  const runDeferredAssets = () => {
    addClarity();
  };

  if ("requestIdleCallback" in window) {
    window.requestIdleCallback(runDeferredAssets, { timeout: 2500 });
    return;
  }

  window.setTimeout(runDeferredAssets, 1200);
};

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <App history={history} />
    </ThemeProvider>
  </Provider>,
);

if (document.readyState === "complete") {
  deferThirdPartyAssets();
} else {
  window.addEventListener("load", deferThirdPartyAssets, { once: true });
}

reportWebVitals();
